import { useState } from "react";

import { PinFrequencyHelper } from "../Helpers/PinFrequencyHelper";
import { LoginPinFrequencyModel } from "../Models/Employee/LoginFrequencyModel";
import { PinFrequency } from "../Models/UI/Enums";
import { useTranslation } from "./useTranslation";

interface IPinFrequencyUIItem {
    title: string;
    initialPinFrequency: PinFrequency;
    onChange: (newPinFrequency: PinFrequency) => void;
}

interface IUsePinFrequencyRequest {
    initialLoginPinFrequency: LoginPinFrequencyModel;
}

interface IUsePinFrequencyReturn {
    pinFrequencyItems: IPinFrequencyUIItem[];
    pinFrequencyState: LoginPinFrequencyModel;
}

/**
 * Get all available PIN frequency options.
 * @param request The initial frequency and states from store.
 */
function usePinFrequency(request: IUsePinFrequencyRequest): IUsePinFrequencyReturn {
    const { getText } = useTranslation();

    const [pinFrequencyState, setPinFrequencyState] = useState<LoginPinFrequencyModel>(() => new LoginPinFrequencyModel(request.initialLoginPinFrequency));
    const pinFrequencyItems: IPinFrequencyUIItem[] = (() => {
        const currentEmployee = sessionStore.getCurrentEmployee();
        const enableQuebecObstetricalPin = currentEmployee?.isQuebecObstetricalFileEnabled() ?? false;
        const enableOntarioObstetricalPin = currentEmployee?.isOntarioObstetricalFileEnabled() ?? false;
        const enableBritishColumbiaObstetricalPin = currentEmployee?.isBritishColumbiaObstetricalFileEnabled() ?? false;

        const options = PinFrequencyHelper.getOptions(
            enableQuebecObstetricalPin,
            enableOntarioObstetricalPin,
            enableBritishColumbiaObstetricalPin
        );

        return options.map(pinFrequencyOptionEnumValue => {
            const initialPinFrequencyValue = PinFrequencyHelper.getFrequency(pinFrequencyState, pinFrequencyOptionEnumValue);

            return {
                title: getText(
                    PinFrequencyHelper.getLabelByPinFrequencyDocumentType(
                        pinFrequencyOptionEnumValue,
                        enableQuebecObstetricalPin,
                        enableOntarioObstetricalPin,
                        enableBritishColumbiaObstetricalPin
                    )
                ),
                initialPinFrequency: initialPinFrequencyValue,
                onChange: newPinFrequency => setPinFrequencyState(PinFrequencyHelper.setFrequency({ ...pinFrequencyState }, pinFrequencyOptionEnumValue, newPinFrequency))
            };
        });
    })();

    return {
        pinFrequencyItems,
        pinFrequencyState
    };
}

export { usePinFrequency };
